function init() {
	const fldSelector = "data-filter-select";
	const btnSelector = "data-filter-btn";
	let filtersOpen = false;
	let params = new URLSearchParams();

	// When filter changes
	const handleFilterChange = (e) => {
		// Loop through all fld filters and disable until page has reloaded
		for (const fld of document.querySelectorAll("[" + fldSelector + "]")) {
			// Listen for when field changes
			fld.setAttribute("disabled", "disabled");
		}

		// Loop through filter fields
		for (const fld of document.querySelectorAll("[" + fldSelector + "]")) {
			// If filter has value selected
			if (fld.value !== "") {
				// Add to list of params
				params.set(fld.name, fld.value);
			}
		}

		// Loop through all btn filters and disable until page has reloaded
		for (const btn of document.querySelectorAll("[" + btnSelector + "]")) {
			// Listen for when field changes
			btn.setAttribute("disabled", "disabled");
		}

		// Get filter element that was changed
		const targetEl = e.target;
		const activeAttr = "aria-selected";

		// If filter element was button, toggle it's active attribute
		if (targetEl.hasAttribute(btnSelector)) {
			targetEl.setAttribute(activeAttr, targetEl.getAttribute(activeAttr) === "true" ? "false" : "true");
		}

		// Loop through active filter btns
		for (const item of document.querySelectorAll("[" + activeAttr + "=true]")) {
			const val = item.getAttribute(btnSelector);

			// Add to list of params
			params.set(val, "true");
		}

		if (filtersOpen) {
			params.set("show-filters", "true");
		}

		// Refresh page with filter params added
		window.location = window.location.pathname + "?" + params.toString() + "#filters";
	};

	// Loop through filter fields...
	for (const fld of document.querySelectorAll("[" + fldSelector + "]")) {
		// Listen for when field changes
		fld.addEventListener("change", handleFilterChange);
	}

	// Loop through filter btns...
	for (const btn of document.querySelectorAll("[" + btnSelector + "]")) {
		// Listen for when field changes
		btn.addEventListener("click", handleFilterChange);
	}

	// Filters toggle button (for showing/hiding filters at mobile size)
	const filtersToggleBtn = document.getElementById("filters-toggle");
	const filtersContainer = document.getElementById("filters-container");

	if (filtersToggleBtn !== null && filtersContainer !== null) {
		filtersToggleBtn.addEventListener("click", () => {
			const numFilters = filtersToggleBtn.getAttribute("data-filters-num");
			let btnText = "";

			if (filtersContainer.hasAttribute("style")) {
				filtersContainer.removeAttribute("style");
				filtersOpen = false;
				btnText = "Show filters";
			} else {
				filtersContainer.style.display = "block";
				filtersOpen = true;
				btnText = "Hide filters";
			}

			if (parseInt(numFilters) > 0) {
				btnText = btnText + " (" + numFilters + ")";
			}

			filtersToggleBtn.innerHTML = btnText;
		});
	}
}

export default init;
